import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  TransmissionRunBatchItemSummaryActions,
  TransmissionRunBatchItemSummaryActionTypes,
} from './transmission-run-batch-item-summary.actions';
import { TransmissionRunBatchItemSummaryEntity } from './transmission-run-batch-item-summary.model';

export type TransmissionRunBatchItemSummaryEntities =
  EntityState<TransmissionRunBatchItemSummaryEntity>;

export const adapter: EntityAdapter<TransmissionRunBatchItemSummaryEntity> =
  createEntityAdapter<TransmissionRunBatchItemSummaryEntity>();

export const initialState: TransmissionRunBatchItemSummaryEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(
  state = initialState,
  incomingAction: Action,
): TransmissionRunBatchItemSummaryEntities {
  const action: TransmissionRunBatchItemSummaryActions =
    incomingAction as TransmissionRunBatchItemSummaryActions;
  switch (action.type) {
    case TransmissionRunBatchItemSummaryActionTypes.AddTransmissionRunBatchItemSummary: {
      return adapter.addOne(action.payload.transmissionRunBatchItemSummary, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.UpsertTransmissionRunBatchItemSummary: {
      return adapter.upsertOne(action.payload.transmissionRunBatchItemSummary, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.AddTransmissionRunBatchItemSummarys: {
      return adapter.addMany(action.payload.transmissionRunBatchItemSummarys, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.UpsertTransmissionRunBatchItemSummarys: {
      return adapter.upsertMany(action.payload.transmissionRunBatchItemSummarys, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.UpdateTransmissionRunBatchItemSummary: {
      return adapter.updateOne(action.payload.transmissionRunBatchItemSummary, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.UpdateTransmissionRunBatchItemSummarys: {
      return adapter.updateMany(action.payload.transmissionRunBatchItemSummarys, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.DeleteTransmissionRunBatchItemSummary: {
      return adapter.removeOne(action.payload.id, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.DeleteTransmissionRunBatchItemSummarys: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.LoadTransmissionRunBatchItemSummarys: {
      return adapter.setAll(action.payload.transmissionRunBatchItemSummarys, state);
    }

    case TransmissionRunBatchItemSummaryActionTypes.ClearTransmissionRunBatchItemSummarys: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
